<suite-rfb-alert-messages></suite-rfb-alert-messages>
<div *ngIf="visaoSelecionada && visaoAto">
    <!-- dados da publicação -->
    <div class="publicacao">{{ visaoAto.dadosPublicacao }}</div>

    <div class="conteudo">
        <app-exibir-visao 
            [visaoAto]="visaoAto"
            [visaoSelecionada]="visaoSelecionada"
            [urlFuncionalidade]="urlFuncionalidade"
            [tipoConsulta]="tipoConsulta"
            [tokenAppRfb]="getTipoComToken()">
        </app-exibir-visao>
    </div>
</div>